<template>
	<CreationWizardStepWrapper>
		<template #header>
			<SlackNativeSettingsHeader v-bind="$props" v-on="$listeners" />
		</template>
		<div class="display-flex height-100 flex-wrap">
			<div class="flex-col-12">
				<div class="top-section">
					<h2 class="med">Choose an <span class="bold">element</span> and a <span class="bold">context</span></h2>
					<h3 class="reg">
						Elements and contexts determine where your feature appears and what data and actions are available to you.
						<a href="https://docs.ply.io/get-started/learn-to-build/lesson-3-context" target="_blank">learn more</a>
					</h3>
				</div>
				<br />
				<ListSelector v-bind="$attrs" :items="slackPlacements" pk="pk" @selectItem="selectPlacement" allowKeyboardNavigation returnObject>
					<template #item-content="{ item: { element_type: elementType, ...placement } }">
						<PlacementRow :placement="placement" :elementType="elementType" />
					</template>
				</ListSelector>
			</div>
			<div class="flex-1 flex-center--end pt-6">
				<!-- <PrimaryButton @click="nextStep">Continue</PrimaryButton> -->
			</div>
		</div>
	</CreationWizardStepWrapper>
</template>

<script>
import WizardStepMixin from '../../WizardStepMixin';
import SlackNativeSettingsHeader from '../SlackNativeSettings/SlackNativeSettingsHeader.vue';
// import props from './ChoosePlacementForAddOn.props';
import PlacementRow from '@/components/CreationWizard/Steps/common/PlacementRow';
import ListSelector from '@/components/common/ListSelector';
// import AppService from '@/utils/AppService';
// import ContextService from '@/utils/ContextService';
// import { isNullOrUndefinedOrEmpty } from '@/utils/helpers';
export default {
	name: 'ChoosePlacementForSlackAddon',
	mixins: [WizardStepMixin],
	components: { SlackNativeSettingsHeader, ListSelector, PlacementRow },
	props: {},
	computed: {},
	methods: {
		selectPlacement(placement) {
			console.log('selectPlacement:', placement);
			this.updateState({ key: 'selectedPlacementId', value: placement.pk });
			this.nextStep();
		},
	},
	data() {
		return {
			tickAfterMount: false,
			slackPlacements: [
				{
					pk: 1,
					element_type: 'feature',
					placement: 'Command bar',
					item_name_prefix: 'Slack Slash Command ',
				},
				{
					pk: 2,
					element_type: 'feature',
					placement: 'Message',
					item_name_prefix: 'Message Shortcut (Soon)',
					disabled: true,
				},
			],
		};
	},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '@/components/CreationWizard/assets/creation-wizard-vars.scss';
.enable-options-text {
	font-size: 12px;
}
.top-section {
	h3 {
		color: $secondary-content-title-font-color;
		a {
			color: $secondary-content-title-font-color;
		}
	}
}
</style>
